import * as $ from "jquery";
declare const Masonry: any;

export default class GridLayout {

	constructor() {
		this.initLayouts();
	}

	initLayouts() {
		$('.grid-layout__container').each((i, el) => {
			console.log("Found a layout, make it work!");
			let layout = new Masonry(el, {
				itemSelector: ".grid-item",
				columnWidth: 300,
				fitWidth: true,
				gutter: 32,
			});
		});
	}
}